import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  closeIcon: {
    position: 'absolute',
  },
  leftIconButton:{
    position: 'absolute',
    left: -36,
    height:30,
    width:30
  },
}));
